import clsx from 'clsx';
import { Outlet, useLocation } from 'react-router-dom';

import ErrorBoundary from '../../components/Core/ErrorBoundary';
import Header from '../../components/Core/Header';

function AuthLayout() {
  const { pathname } = useLocation();
  // Extension authorize is a chrome-free consent surface (popup / redirect).
  const shouldShowHeader = pathname !== '/extension/authorize';

  return (
    <>
      <div className="flex h-full w-full overflow-hidden bg-white">
        {shouldShowHeader && <Header />}
        <main
          className={clsx(
            'relative flex w-screen flex-1 shrink overflow-x-hidden transition-all duration-300',
            shouldShowHeader ? 'mt-[var(--app-header-stack-height,3.5rem)]' : 'mt-0',
          )}
        >
          <div className="m-auto max-w-2xl overflow-auto">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </div>
        </main>
      </div>
    </>
  );
}

export default AuthLayout;
